import * as React from 'react';

import type { Article } from 'schema-dts';

import config from 'js/app/config';

import GoogleMarkup from 'bundles/seo/components/GoogleMarkup';
import { getTimeRequiredString } from 'bundles/seo/utils/schemaMarkupUtils';
import type { AuthorProfile } from 'bundles/shared-articles/components/ArticleAuthorProfile';
import {
  createAuthorsSchema,
  createBreadcrumbsListSchema,
  createGraph,
} from 'bundles/shared-articles/components/seo/utils/schemaMarkupUtils';
import type { Breadcrumb } from 'bundles/shared-articles/components/seo/utils/schemaMarkupUtils';

type InputProps = {
  title: string;
  createdAt?: string;
  updatedAt?: string;
  imageUrls?: Array<string | null | undefined> | [];
  estimatedReadTime?: number;
  breadcrumbs: Breadcrumb[];
  id: string;
  authors?: AuthorProfile[];
};

type Props = InputProps;

export const ArticleGoogleSchemaMarkup = ({
  title,
  createdAt,
  updatedAt,
  imageUrls,
  estimatedReadTime,
  breadcrumbs,
  id,
  authors,
}: Props) => {
  const authorsSchema = createAuthorsSchema(authors || []);

  const articleType: Article = {
    '@id': id,
    '@type': 'Article',
    headline: title,
    image: imageUrls?.length && imageUrls[0] ? imageUrls[0] : undefined,
    datePublished: createdAt,
    dateModified: updatedAt,
    timeRequired: estimatedReadTime ? getTimeRequiredString({ milliseconds: estimatedReadTime * 60000 }) : undefined,
    author: authorsSchema,
    publisher: {
      '@type': 'Organization',
      name: 'Coursera',
      url: `${config.url.base}`,
      logo: `${config.url.imageProxyRoot}https://coursera.s3.amazonaws.com/media/coursera-logo-square.png`,
    },
  };

  const breadcrumbType = createBreadcrumbsListSchema(breadcrumbs);

  return <GoogleMarkup graph={createGraph([articleType, breadcrumbType])} />;
};

export default ArticleGoogleSchemaMarkup;
